import WebsiteBehaviors from "../website-behaviors/index.js";
import Citation from "../citation.js";
import {waitUntil} from "../utils/async.js";

let proQuestRisArray: string[];
function setProQuestRisArray(event: CustomEvent<string[]>): void {
	proQuestRisArray = event.detail;
}

class ProQuestCongressional extends WebsiteBehaviors {
	identifier() {
		return "ProQuestCongressional";
	}

	static test(location: Location) {
		return location.host.endsWith("congressional.proquest.com")
			|| location.host === "public.cambraca.com" // TODO: remove these
			|| location.host === "publicssl.cambraca.com";
	}

	async init(): Promise<void> {
		if (window === window.top) { // only in top frame
			document.addEventListener("pn-proquest-ris-object", setProQuestRisArray);
			document.dispatchEvent(new CustomEvent("pn-get-proquest-ris-object"));
			try {
				await waitUntil(() => {
					if (proQuestRisArray)
						return true;
					else {
						document.dispatchEvent(new CustomEvent("pn-get-proquest-ris-object"));
						return false;
					}
				});
			} catch (e) {
				console.warn("PN: Couldn't get ProQuest RIS data.", e);
			}
			document.removeEventListener("pn-proquest-ris-object", setProQuestRisArray);
		}

		return super.init();
	}

	initMainWorld() {
		if (window !== window.top) // only in top frame
			return;

		document.addEventListener("pn-get-proquest-ris-object", () => {
			// @ts-expect-error TS(2551)
			const detail = Array.isArray(window.RisObject) ? window.RisObject : [];
			if (!detail.length)
				return;
			document.dispatchEvent(new CustomEvent<string[]>("pn-proquest-ris-object", {detail}));
		});
	}

	async generateStructuredCitation() {
		// @ts-expect-error TS(2551)
		const risArray: string[] = proQuestRisArray ?? window?.RisObject ?? [];

		if (risArray === undefined || typeof risArray !== "object" || risArray.length === 0)
			return null;

		return Citation.fromRIS(risArray.join("\r\n"));
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'processOrgProxy' implicitly has an 'any... Remove this comment to see the full error message
	getPageUrl(processOrgProxy, isClean = false): string {
		return this.getProQuestCongressionalPageUrl(processOrgProxy)
			?? super.getPageUrl(processOrgProxy, isClean);
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'processOrgProxy' implicitly has an 'any' type.
	getProQuestCongressionalPageUrl(processOrgProxy): string | null {
		const url = this.getSingleRisValue("UR");
		if (url && (url.startsWith("http://") || url.startsWith("https://")))
			return processOrgProxy(url);
		else
			return null;
	}

	getProQuestCongressionalPageTitle(): string | null {
		// @ts-ignore - RisObject is not defined
		const title = this.getSingleRisValue("TI")
			?? this.getSingleRisValue("T1")
			?? this.getSingleRisValue("CT")
			?? this.getSingleRisValue("BT");
		if (title)
			return title;
		else
			return document.querySelector("head > title")?.textContent?.trim() ?? null;
	}

	getSingleRisValue(name: string): string | undefined {
		// @ts-expect-error TS(2551)
		const risArray: string[] = proQuestRisArray ?? window?.RisObject ?? [];
		const prefix = name + "  - ";
		return risArray.find((line: string) => line.startsWith(prefix))?.substring(prefix.length).trim();
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
	async mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy): Promise<boolean> {
		const pageUrl = this.getProQuestCongressionalPageUrl(processOrgProxy);
		if (pageUrl) {
			const pageTitle = this.getProQuestCongressionalPageTitle() ?? pageUrl;
			page.setPageDataOverride({pageUrl, pageTitle});
		}

		return super.mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy);
	}
}

export default ProQuestCongressional;
